// extracted by mini-css-extract-plugin
var _1 = "EmailPreviewUserField-modulefield__aXBzJ";
var _2 = "EmailPreviewUserField-modulelabel__VmFRA";
export { _1 as "field", _2 as "label" }
